import { jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import "react";
import { Icon } from "../../../Icon/index.js";
import { Box } from "../../../Box/index.js";
const PopupIcon = (t0)=>{
    const $ = c(4);
    const { className, mx: t1 } = t0;
    const mx = void 0 === t1 ? "4" : t1;
    let t2;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ jsx(Icon, {
            name: "arrow_triangle_down",
            size: "16",
            color: "text.dark.secondary"
        });
        $[0] = t2;
    } else t2 = $[0];
    let t3;
    if ($[1] !== className || $[2] !== mx) {
        t3 = /*#__PURE__*/ jsx(Box, {
            className: className,
            mx: mx,
            children: t2
        });
        $[1] = className;
        $[2] = mx;
        $[3] = t3;
    } else t3 = $[3];
    return t3;
};
export { PopupIcon };
